// 同じキャンバスに参加しているユーザーのプレゼンス（一覧 + カーソル位置）を管理する Zustand store。
// useRealtimeConnection が viewer.snapshot / viewer.cursor を購読してこのストアを更新する。

import { create } from "zustand";
import type { Viewer } from "@refinement-canvas/domain";

export interface ViewerCursor {
  readonly xRatio: number;
  readonly yRatio: number;
  readonly updatedAt: number;
}

interface CanvasViewersState {
  /** 自分以外を含む全参加者（自分の userId は除外する想定だが、サーバ側で同梱されている場合もある） */
  viewers: Record<string, Viewer>;
  /** userId -> 最新カーソル位置 */
  cursors: Record<string, ViewerCursor>;

  setViewers: (viewers: readonly Viewer[]) => void;
  setCursor: (userId: string, cursor: ViewerCursor | null) => void;
  reset: () => void;
}

export const useCanvasViewersStore = create<CanvasViewersState>((set) => ({
  viewers: {},
  cursors: {},
  setViewers: (viewers) =>
    set(() => ({
      viewers: Object.fromEntries(viewers.map((v) => [v.userId, v])),
    })),
  setCursor: (userId, cursor) =>
    set((state) => {
      if (cursor === null) {
        const next = { ...state.cursors };
        delete next[userId];
        return { cursors: next };
      }
      return { cursors: { ...state.cursors, [userId]: cursor } };
    }),
  reset: () => set({ viewers: {}, cursors: {} }),
}));
